import React, { Component, Fragment } from 'react';
import { ReactComponent as CargoInfo } from 'Icons/cargoinfo.svg';
import Input from 'Components/Input';
import Select from 'react-select';
import {
    CARGO_DETAILS,
    HANDLING_INSTRUCTIONS,
    CARGO_TYPE
} from 'Constants/commonConstants';
import { ReactComponent as Tick } from 'Icons/tick.svg';
import Cx from 'classnames';
import Checkbox from 'Components/Checkbox/index';

class CargoInformation extends Component {
    constructor(props) {
        super(props);
        this.cargoInfo = props.cargoInfo;
        this.material_packing_list = props.material_packing_list;
        this.state = {
            isTemperatureCardShown : false,
            cargoInfo: this.cargoInfo,
        }
        this.viewMode = props.viewMode;
    }

    toggleCargo = (option)=> {
        if(this.viewMode) {
            return;
        }
        const cargoDetails = (option || []).map(el => el.value);
        this.cargoInfo.setCargoDetails(cargoDetails);
        this.setState({
            cargoInfo: this.cargoInfo
        })
        this.props.onChange();
    }

    onDescriptionChange = (e) => {
        if(this.viewMode) {
            return;
        }
		 this.cargoInfo.setCargoDescription(e.target.value);
        this.setState({
            cargoInfo: this.cargoInfo
        });
    }

    selectProductCategory = (productCategory, isMulti)=> {
        if(this.viewMode) {
            return;
        }
        this.cargoInfo.setProductCategory(productCategory.value, productCategory.name);
        this.cargoInfo.setProductDensity(productCategory.density);
        this.setState({
            cargoInfo: this.cargoInfo
        })
    }

    selectPackingType = (packingType,)=> {
        if(this.viewMode) {
            return;
        }
        this.cargoInfo.setPackingType(packingType.value, packingType.name);
        this.setState({
            cargoInfo: this.cargoInfo
        })
        this.props.onChange();
    }

    toggleInstructions = (value)=> {
        if(this.viewMode) {
            return;
        }
        const isntructionValue = value;
        const handlingInstructions = [...this.cargoInfo.handlingInstructions];
        const index = handlingInstructions.indexOf(isntructionValue);
        if(index < 0) {
            handlingInstructions.push(isntructionValue);
            // if(isntructionValue === 2) {
            //     this.showTemperatureCard();
            // }
        } else {
            handlingInstructions.splice(index, 1);
        }
        this.cargoInfo.setHandlingInstructions(handlingInstructions);
        this.setState({
            cargoInfo: this.cargoInfo
        });
        this.props.onChange();
    }

    changeCargoType = (value) => {
        if(this.viewMode) {
            return;
        }
        this.cargoInfo.setCargoType(value);
        this.setState({
            cargoInfo: this.cargoInfo
        });
    }

    render() {
        const { packingTypes, productCategories, submitted, rfqType } = this.props;
        return (
            <div className='cargoInfo ph-30 pv-30 mt-10'>
                <div className='header flex'>
                    <CargoInfo />
                    <div className='ml-10'>Cargo Information</div>
                </div>
                <div className='flex pt-20'>
                    {[13,14,15].includes(rfqType) && <div className='col-2'>
                        <div className='rfqlabel'>Cargo Type <sup className='error-color fs-14'>*</sup></div>
                        <div className="flex mb-10 mt-10 rfqValue">
                            {(CARGO_TYPE || []).map(el =>( <Checkbox label={el.name} checked = {this.cargoInfo.cargoType === el.value} className="mr-20 mb-5" onCheck={() => this.changeCargoType(el)}/>))}
                        </div>
                    </div>}
                    <div className={Cx('', {
                        'col-2': [13,14,15].includes(rfqType),
                        'col-1': ![13,14,15].includes(rfqType)
                    })}>
                         <div className='rfqlabel'>Cargo Details <sup className='error-color fs-14'>*</sup>                     
                            {submitted && !this.cargoInfo.cargoDetails.length && <span className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Atleast One</span>}
                        </div>
                        <Select 
                            options={CARGO_DETAILS}
                            getOptionLabel={option => option.name}
                            isMulti
                            value={CARGO_DETAILS.filter(el => ((this.cargoInfo || {}).cargoDetails || []).includes(el.value))}
                            onChange={this.toggleCargo}
                        />
                    </div>
                </div>
                <div className='pt-20'>
                    <div className='rfqlabel'>Cargo Description</div>
                    <textarea 
                        className='cargoInput col-1 p-10'  
                        cols={4} 
                        placeholder='Enter Cargo description here...' name="Cargo Description"
                        value={this.cargoInfo.cargoDescription}
                        onChange={this.onDescriptionChange}/>
                </div>
                <div className='flex pt-20'>
                    <div className='col-2 mr-15'>
                        <div className='rfqlabel'>Product Categories</div>
                        <Select 
                            options={productCategories}
                            getOptionLabel={(option) => option.name}
                            value={productCategories.find((productCategory)=> {
                                return productCategory.value === this.cargoInfo.productCategory
                            })}
                            onChange={this.selectProductCategory}
                        />
                    </div>
                    <div className='col-2 ml-15'>
                        <div className='rfqlabel'>Packaging Type <sup className='error-color fs-14'>*</sup>
                            {(submitted && !this.cargoInfo.packingType) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Select The Field</span>}
                        </div>
                        <Select
                            options={packingTypes}
                            getOptionLabel={(option) => option.name}
                            onChange={this.selectPackingType}
                            value={packingTypes.find((packingType) => {
                                return packingType.value === this.cargoInfo.packingType
                            })}
                        />
                    </div>
                </div>
                <div className='pt-20'>
                    <div className='subHeader'>Handling Instruction</div>
                    <div className='hValues mt-10 flex flex-wrap'>
                            {(HANDLING_INSTRUCTIONS || []).map((el, index) => {
                            return (
                            <div className={Cx('hData flex mb-10 curP', {
                                'active': (this.cargoInfo.handlingInstructions || []).includes(el.value)
                            })} onClick={() => this.toggleInstructions(el.value)}>
                                {(this.cargoInfo.handlingInstructions || []).includes(el.value) && <Tick className='mr-5'/>}
                                <div>{el.name}</div>
                            </div>)})}
                    </div>
                </div>
            </div>
        )
    }
}

export default CargoInformation;